import React, { useEffect, useState } from "react";
import "./Home.css";
import UpcomingTrips from "../components/UpcomingTrips";
import Testimonials from "../components/Testimonials";
import OurNumbers from "../components/Numbers";
import FAQs from "../components/FAQSection";
import MonthlyOffers from "../components/MonthlyOffers";
const Home = () => {
  const [banners, setBanners] = useState([]);

  const SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQs4YFHBHBvQ3sQnE13Me6yoWoArGu8Kmx2hTXxzH5a100wx93EwSFoYF5SbTxEj2nE8BJnbH_Z-Jea/pub?output=csv"; // Replace with your actual published link

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.text())
      .then((csvText) => {
        const rows = csvText.split("\n").slice(1); // Skip header row
        const data = rows.map((row) => {
          const [ImageURL, Link] = row.split(",");
          return { ImageURL, Link };
        });
        setBanners(data);
      });
  }, []);

  return (
    <div className="home-page">
      <section className="banner-slider">
        <div className="slider-container">
          {banners.map((item, index) => (
            <a href={item.Link} key={index} target="_blank" rel="noopener noreferrer">
              <img src={item.ImageURL} alt={`Banner ${index}`} className="banner-image" />
            </a>
          ))}
        </div>
      </section>
      <MonthlyOffers />
      <UpcomingTrips/>
      <OurNumbers/>
      <Testimonials/>
      <FAQs/>
    </div>
  );
};

export default Home;
